'use strict';

var $ = require('jquery');
var ContextMenuDirective = function ContextMenuDirective($document) {
  return {
    restrict: 'E',
    replace: true,
    require: '^rmGridPanel',
    template: require('../templates/context-menu.html'),
    link: function link(scope, element) {
      var gridElement = element.parent().find('.generic-grid div');
      scope.triggerContextMenuAction = function (item) {
        if (!item.disabled) {
          scope.$emit(item.event, scope.getSelectedRows());
        }
        element.hide();
      };
      gridElement.on('contextmenu', function () {
        return false;
      });
      gridElement.on('rowclick', function (event) {
        if (event.args.rightclick) {
          var selectedRows = gridElement.jqxGrid('getselectedrowindexes');
          if (selectedRows.length === 1 && scope.contextMenuShowWhenOnlyOneRowSelected || selectedRows.length > 0 && !scope.contextMenuShowWhenOnlyOneRowSelected) {
            element.css({
              display: 'block',
              left: parseInt(event.args.originalEvent.clientX) + 5 + $(window).scrollLeft(),
              top: parseInt(event.args.originalEvent.clientY) + 5 + $(window).scrollTop()
            });
          }
          return false;
        }
      });
      function hideOnWindowClick(event) {
        if ($(event.target).closest(element).length === 0) {
          element.hide();
        }
      }
      $document.on('click', hideOnWindowClick);
      element.on('$destroy', function () {
        $document.off('click', hideOnWindowClick);
      });
    }
  };
};
ContextMenuDirective.$inject = ['$document'];
module.exports = ContextMenuDirective;